import memoize from "memoizee";
// Default cache expiry time (5 minutes)
var CACHE_EXPIRY_TIME = 1000 * 60 * 5;
/**
 * Creates an API wrapper that caches responses when the same request payload is used.
 * Responses are used for up to 5 minutes and then are evicted from caches. This is
 * particularly useful for supporting quick back and forth navigation between list and
 * detail views.
 * @deprecated use react-query instead, which supports all the functionality in this utility. query hooks are provided by web-api.
 */ export var cachingApi = function(apiCall, optionsOrCacheExpiryTime) {
    var options = typeof optionsOrCacheExpiryTime === "number" ? {
        cacheExpiryTime: optionsOrCacheExpiryTime
    } : optionsOrCacheExpiryTime;
    var _options_cacheExpiryTime;
    return memoize(apiCall, {
        normalizer: function(args) {
            var obj = {
                0: args[0]
            };
            for(var i = 1; i < 4; i++){
                if (args[i]) {
                    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                    obj[i] = args[i];
                }
            }
            return JSON.stringify(obj);
        },
        maxAge: (_options_cacheExpiryTime = options === null || options === void 0 ? void 0 : options.cacheExpiryTime) !== null && _options_cacheExpiryTime !== void 0 ? _options_cacheExpiryTime : CACHE_EXPIRY_TIME,
        length: 4,
        promise: true,
        preFetch: options === null || options === void 0 ? void 0 : options.refetchBeforeExpiry
    });
};
export var cachingApiWithLookup = function(apiCall, cacheExpiryTime) {
    return {
        cache: cachingApi(apiCall, cacheExpiryTime),
        lookup: new Set()
    };
};
